// extracted by mini-css-extract-plugin
export var bar = "SearchBoxConnector-module--bar--ef85a";
export var barWrapper = "SearchBoxConnector-module--barWrapper--c7f92";
export var bsbWidgetContainer = "SearchBoxConnector-module--bsbWidgetContainer--6d3ea";
export var heading = "SearchBoxConnector-module--heading--ebcb6";
export var packages = "SearchBoxConnector-module--packages--415d9";
export var placeholder = "SearchBoxConnector-module--placeholder--e68d6";
export var sectionContainer = "SearchBoxConnector-module--sectionContainer--358a2";
export var widgetWrapper = "SearchBoxConnector-module--widgetWrapper--89715";